const NegotiationButtonVariant = {
  close: 'Send to Closing',
  start: 'Start negotiation',
  respond: 'Respond',
  view: 'View negotiation'
};

export default NegotiationButtonVariant;
